angular
    .module('dashboard')
    .directive('monacoEditor',
        function ($timeout) {
            return {
                scope: {
                    model: '=',
                    value: '=',
                    language: '@language'
                },
                template: '',
                restrict: 'A',
                link: function (scope, elm, attr) {
                    if (window.IN_TEST) {
                        return;
                    }
                    require.config({paths: {'vs': './scripts/monaco/vs'}});
                    require(['vs/editor/editor.main'], function () {
                        var id = elm.attr("id");
                        scope.model = monaco.editor.create(document.getElementById(id), {
                            language: scope.language,
                            value: scope.value,
                            automaticLayout: true,
                            wordWrap: "wordWrapColumn",
                            wordWrapColumn: 100,
                        });
                        lazyApply();
                    });

                    /**
                     * lazily apply due to monaco not binding to the passed in model on first digest
                     */
                    function lazyApply() {
                        $timeout(function(){}, 0);
                    };
                }
            };
        });

